export const messages = {
  harvestSaleLots: {
    lotBanner: {
      title: 'Логистические сервисы',
      description: 'Грузоперевозки, экспедирование, инспекция груза',
      button: 'Подробнее',
    },
  },
}
